import styled, { css } from "styled-components";

import { size } from "~/styles/screen";
import { from } from "~/styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  background: #f8f8f8;
  @media screen and (max-width: ${size.small}) {
    flex-direction: column;
  }
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  background: #f8f8f8;
  @media screen and (max-width: ${size.small}) {
    flex-direction: column;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${size.small}) {
    flex-direction: column;
  }
`;

export const LightBlurSection = styled.div`
  filter: blur(2px);
  width: 100%;
`;

export const UserBox = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 44px;
  min-width: 425px;
  height: 100%;

  @media screen and (max-width: ${size.small}) {
    justify-content: center;
    align-items: center;
    min-width: 300px;
    padding: 11px;
  }
`;

export const UserBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SunriseInfo = styled.text`
  font-size: 12px;
  line-height: 17px;
  font-weight: 400;
  font-family: "Open Sans";
  display: flex;
  color: #8e8e8e;
  text-align: center;
  margin-top: 10px;
`;

export const SunriseInfoBold = styled.a`
  font-size: 12px;
  line-height: 17px;
  font-weight: 800;
  font-family: "Open Sans";
  display: flex;
  color: #8e8e8e;
  align-self: center;

  @media screen and (max-width: ${size.small}) {
    margin-bottom: 20px;
  }
`;

export const VASPInfo = styled.div`
  ${from.mobile(css`
    padding: calc(0.7rem * 1);
  `)}
  ${from.tablet(css`
    padding: calc(0.7rem * 2);
  `)}
  ${from.desktop(css`
    padding: calc(0.7rem * 4);
  `)}
  padding-top: 0 !important;
  padding-bottom: 67px;
`;
